import { render } from "./Roadmap.vue?vue&type=template&id=2a9892dc&scoped=true"
const script = {}

import "./Roadmap.vue?vue&type=style&index=0&id=2a9892dc&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2a9892dc"

export default script